import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import React from "react";
import OchaIcon from "./OchaIcon";

const timelineData = [
    {
        date: "2006–2008",
        description: "Transformed villages like Kadepur, Kadegaon, and Ramapur into \"Clean Gram Panchayats\" under Swachhata Abhiyan and Nirmal Gram Yojana by mobilizing communities for toilet construction and preparing DPRs for solid waste and sanitation management, effectively eliminating open defecation and fostering a culture of hygiene.",
        icon: "Sanitation",
    },
    {
        date: "2007–2010",
        description: "Strengthened rural water security by executing tap water schemes at Dongrai Devi Temple (Kadepur) and nearby villages, serving as the technical partner for the Aapal Pani Project in 4 Pune villages, and enhancing groundwater sustainability through detailed DPRs in 33 villages across Latur, Osmanabad, and Sangli districts.",
        icon: "Water-source",
    },
    {
        date: "2007–2014",
        description: "Promoted sustainable farming and ecological balance by conducting organic fertilizer workshops, distributing native tree saplings for social forestry, and leading waste management and composting awareness campaigns under Rashtriya Paryavaran Mohim in four Kadegaon villages.",
        icon: "Agriculture",
    },
    {
        date: "2008–2011",
        description: "Empowered below-poverty-line women in Kadegaon taluka by forming 238 Self-Help Groups (SHGs) under the Swarnajayanti Gram Swarojgar Yojana, fostering financial inclusion through bank linkages and enabling sustainable, microfinance-driven livelihoods.",
        icon: "Gender",
    },
    {
        date: "2007–2013",
        description: "Enhanced community health and education by organizing polio booths, blood donation camps, and educational \"talking walls,\" and by establishing e-learning centers equipped with computers and trained teachers in schools such as Z.P. School, Kadepur.",
        icon: "Education",
    },
    {
        date: "2009–2016",
        description: "Strengthened local ecosystem governance by establishing biodiversity committees and public registers across multiple talukas, while empowering women farmers in 25 Kadegaon villages to adopt improved, sustainable agricultural practices for enhanced productivity and resilience.",
        icon: "Environment",
    },
    {
        date: "2010–2016",
        description: "Served as the Project Implementation Agency for the Integrated Watershed Management Programme (IWMP) across 50+ villages in Sangli, Kolhapur, and Satara districts, enhancing soil and water conservation while training SHGs in agro-based livelihoods impacting over 70 villages with improved sustainability and income generation.",
        icon: "Water-Sanitation-and-Hygiene",
    },
    {
        date: "2016–2021",
        description: "Forged CSR partnerships with the Bank of Maharashtra to strengthen SHG capacities and organized vital community health camps during the COVID-19 pandemic, ensuring continuity of support and well-being for rural families.",
        icon: "Partnership",
    },
    {
        date: "2017–2021",
        description: "As a Key Resource Center (KRC) for the National Jal Jeevan Mission (NJJM), spearheaded state-level education and communication initiatives across Maharashtra and Goa, implemented village action plans in 56 Kadegaon villages, and championed efficient water use through drip irrigation and conservation campaigns in 131 Sangli villages.",
        icon: "Potable-water",
    },
    {
        date: "2017–2021",
        description: "Advanced women's economic empowerment by delivering vocational trainings in tailoring, jewelry making, and dairy production across 100+ villages, linking 200 SHGs to microfinance and enterprise opportunities, and conducting digital and legal literacy workshops to strengthen women's financial and social agency.",
        icon: "Group",
    },
    {
        date: "2017–2025",
        description: "Enhanced climate-resilient agriculture by strengthening farmer groups under the Maharashtra Agriculture Competitiveness Project, promoting large-scale afforestation in Tasgaon, and advancing crop diversification in the salinity-affected zones of Palus.",
        icon: "Food-Security",
    },
    {
        date: "2016–2025",
        description: "Strengthened ecological conservation by completing public biodiversity registers for over 270 villages in Sangli and Solapur, conducting CSR-funded trainings on biodegradable leaf-plate production in 77 Sindhudurg villages, and implementing community-based measures to mitigate human–wildlife conflict in 10 villages.",
        icon: "Environment",
    },
    {
        date: "2021–2025",
        description: "Strengthened child protection and community development by operating 24-hour Childline services at Miraj Railway Station to safeguard vulnerable children, while sustaining self-funded e-learning and women's skill development programs that foster long-term social empowerment.",
        icon: "Child-protection",
    },
    {
        date: "2022–2025",
        description: "Demonstrated continued leadership under Jal Jeevan Mission Phases 3–4 by facilitating community-led water monitoring, capacity building, and source sustainability planning in over 40 villages, ensuring long-term water security and resilience.",
        icon: "Protection",
    },
];

const OrgTimeline = ({ darkMode }) => {
    return (
        <VerticalTimeline lineColor={darkMode ? "#A5D6A7" : "#2E7D32"}>
            {timelineData.map((item, index) => (
                <VerticalTimelineElement
                    key={index}
                    className="vertical-timeline-element--work"
                    contentStyle={{
                        background: darkMode ? '#1B3A1B' : '#E8F5E9',
                        color: darkMode ? '#fff' : '#212529',
                        borderTop: `3px solid ${darkMode ? '#A5D6A7' : '#2E7D32'}`
                    }}
                    contentArrowStyle={{ borderRight: `7px solid ${darkMode ? '#1B3A1B' : '#E8F5E9'}` }}
                    date={item.date}
                    dateClassName="timeline-date"
                    iconStyle={{ background: '#2E7D32', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    icon={<OchaIcon name={item.icon} size={24} color="white" />}
                >
                    <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.7' }}>{item.description}</p>
                </VerticalTimelineElement>
            ))}
            <VerticalTimelineElement
                iconStyle={{ background: '#388E3C', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                icon={<OchaIcon name="Community-engagement" size={24} color="white" />}
            />
        </VerticalTimeline>
    );
};

export default OrgTimeline;
